import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { Observable } from 'rxjs';

import { CountryModel } from '../../model/country.model';
import { IndividualPhoneModel } from '../../model/individual-phone.model';
import { WizardService } from '../../wizard/wizard.service';
import { PhoneTypeCodeMap } from './../../data/phone-type';
import { PhoneService } from './phone.service';

@Component({
  selector: 'app-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.css']
})
export class PhoneComponent implements OnInit {

  public faPlus = faPlus;

  @Input()
  public OnSaveEvent: EventEmitter<any>;

  @Input()
  public Country: CountryModel;

  @Input()
  public isSaving: boolean;

  public Phones: Observable<IndividualPhoneModel[]>;

  public array: UntypedFormArray = new UntypedFormArray([]);

  public get Groups(): UntypedFormGroup[] {
    return this.array.controls as UntypedFormGroup[];
  }

  public get Valid(): boolean {
    return this.array.valid;
  }

  private delete: Set<string> = new Set();

  private busy: Set<string | AbstractControl> = new Set();

  constructor(
    private service: PhoneService,
    private wizard: WizardService
  ) {
  }

  ngOnInit() {
    this.Phones = this.service.GetPhones();

    const first = this.addPhone(true);

    this.Phones.subscribe(result => {
      let primary: IndividualPhoneModel;

      if (result.length) {
        primary = result.find(phone => phone.cph_primary);
        if (!primary) {
          primary = result[0];
          primary.cph_primary = true;
        }

        for (const phone of result) {
          if (phone === primary) {
            continue;
          }

          const fields = this.addPhone(true);
          fields.reset(phone);
        }
      } else {
        primary = new IndividualPhoneModel();
        primary.cph_primary = true;
        primary.cph_pht_key = PhoneTypeCodeMap.Mobile.pht_key;
        primary.phn_cty_key = this.Country.cty_key;
      }

      first.reset(primary);
    });

    this.OnSaveEvent.subscribe(_ => this.onSave());
  }

  public onSave() {
    // Delete removed phone numbers
    for (const key of Array.from(this.delete)) {
      if (this.busy.has(key)) {
        continue;
      }

      this.busy.add(key);

      this.wizard.waitOn(this.service.DeletePhone(key)).subscribe(result => {
        if (result) {
          this.delete.delete(key);
          this.busy.delete(key);
        }
      });
    }

    // Save phone numbers
    for (const field of this.array.controls) {
      if (field.dirty) {
        if (this.busy.has(field)) {
          continue;
        }

        this.busy.add(field);

        const phone = new IndividualPhoneModel(field.value);
        this.wizard.waitOn(this.service.SavePhone(phone)).subscribe(result => {
          this.busy.delete(field);
          field.reset(result);
        });
      }
    }
  }

  public addPhone(required: boolean = false): UntypedFormGroup {
    const phone = new UntypedFormGroup({
      cph_key: new UntypedFormControl(null),
      cph_primary: new UntypedFormControl(null),
      phn_number: new UntypedFormControl(null, required ? [Validators.required] : []),
      cph_extension: new UntypedFormControl(null),
      cph_pht_key: new UntypedFormControl(PhoneTypeCodeMap.Mobile.pht_key, required ? [Validators.required] : []),
      phn_cty_key: new UntypedFormControl(this.Country.cty_key)
    });

    this.array.push(phone);

    return phone;
  }

  public removePhone(index: number) {
    if (this.array.length > index && index !== 0) {
      const fields = this.array.at(index);
      if (fields.value.cph_key) {
        this.delete.add(fields.value.cph_key);
      }

      this.array.removeAt(index);
    }
  }
}
